import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PurchaseOrder, PurchaseOrderCreate, PurchaseOrderFilter } from '../data/purchaseOrder';

export function createPurchaseOrderService(client: AxiosInstance) {
  return createCrudService<PurchaseOrder, PurchaseOrderCreate, PurchaseOrderFilter>(client, '/PurchaseOrder', 'purchaseOrderId');
}

export type PurchaseOrderService = CrudService<PurchaseOrder, PurchaseOrderCreate, PurchaseOrderFilter>;
